import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { Vector4 } from "../../../maths/Vector4";
import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { RenderClearFlag } from "../../../RenderEngine/RenderEnum/RenderClearFlag";
import { Viewport } from "../../../maths/Viewport";
export class RenderContext3D {
    static __init__() {
        RenderContext3D._instance = new RenderContext3D();
        this.GammaCorrect = Shader3D.getDefineByName("GAMMACORRECT");
    }
    get camera() {
        return this._camera;
    }
    set camera(value) {
        this._camera = value;
        this._contextOBJ.cameraModuleData = value ? value._renderDataModule : null;
    }
    set destTarget(value) {
        this._contextOBJ.setRenderTarget(value ? value._renderTarget : null, RenderClearFlag.Nothing);
    }
    set viewport(value) {
        this._contextOBJ.setViewPort(value);
    }
    set scissor(value) {
        this._contextOBJ.setScissor(value);
    }
    get invertY() {
        return this._contextOBJ.invertY;
    }
    set invertY(value) {
        this._contextOBJ.invertY = value;
    }
    get pipelineMode() {
        return this._contextOBJ.pipelineMode;
    }
    set pipelineMode(value) {
        this._contextOBJ.pipelineMode = value;
    }
    get cameraShaderValue() {
        return this._contextOBJ.cameraData;
    }
    set cameraShaderValue(value) {
        this._contextOBJ.cameraData = value;
    }
    get scene() {
        return this._scene;
    }
    set scene(value) {
        if (value) {
            this._contextOBJ.sceneData = value._shaderValues;
            this._scene = value;
            this._contextOBJ.sceneModuleData = value._sceneModuleData;
        }
        else {
            this._contextOBJ.sceneModuleData = null;
            this._contextOBJ.sceneData = null;
            this._scene = null;
        }
    }
    changeViewport(x, y, width, height) {
        Viewport.TEMP.set(x, y, width, height);
        this.viewport = Viewport.TEMP;
    }
    changeScissor(x, y, width, height) {
        Vector4.TEMP.setValue(x, y, width, height);
        this.scissor = Vector4.TEMP;
    }
    applyContext(cameraUpdateMark) {
        this._contextOBJ.cameraUpdateMask = cameraUpdateMark;
    }
    drawRenderElement(renderelemt) {
        this._contextOBJ.drawRenderElementOne(renderelemt);
    }
    constructor() {
        this.configPipeLineMode = "Forward";
        this._contextOBJ = Laya3DRender.Render3DPassFactory.createRenderContext3D();
    }
}
